import DefaultDetail from "@Common/DefaultDetail";
import "./style.scss";

const Ghost = ({ setStep, step, countOfSteps }) => {
    const input = [
        {
            blockName: "Настройки модального окна оффера призрака",
            inputs: {
                label: {
                    type: "label",
                    label: "Укажите конфигурацию оффера",
                },
                ghostOfferConfig: {
                    type: "objectInputs",
                    inputs: {
                        textTitle: {
                            type: "string",
                            addClass: "full",
                            label: "Заголовок модального окна",
                            required: true,
                        },
                        textDesc: {
                            type: "string",
                            addClass: "full",
                            label: "Описание модального окна",
                            required: true,
                        },
                        typeOffer: {
                            type: "radiobutton",
                            radioButtonData: [
                                { label: "Обычное модальное окно", value: false, radioNode: { type: "defaultCard", previewType: "ghostDefault" } },
                                { label: "Модальное окно + ввод почты", value: true, radioNode: { type: "defaultCard", previewType: "ghostEmail" } },
                            ],
                            defaultValue: false,
                        },

                        textAnswer: {
                            type: "textArea",
                            addClass: "full",
                            label: "Укажите заголовок модального окна",
                            required: true,
                            triggerShow: "ghostOfferConfig.typeOffer",
                            triggerShowValue: true,
                        },

                        ghostHeader: {
                            previewType: "ghostHeader",
                            type: "defaultCard",
                            addClass: "full",
                            triggerShow: "ghostOfferConfig.typeOffer",
                            triggerShowValue: true,
                        },
                    },
                },
            },
        },
    ];

    return <DefaultDetail apiUrl={"/promo/offers"} inputs={input} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />;
};

export default Ghost;
